// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3rim1","clinicsSelect":"TableHeading_clinicsSelect__5kdZM"};